import {createSlice} from '@reduxjs/toolkit'
import { getAppSettings } from 'sr/redux/action/master/appSettingsAction'
interface appSettingsType {
    data:any,
    status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}
const initialState:appSettingsType = {
    data:null,
    status:'idle',
    error:null
}
const appSettingsSlice = createSlice({
    name:'appSettings',
    initialState,
    reducers:{},
    extraReducers:(builder)=> {
        builder.addCase(getAppSettings.pending, (state)=> {
            state.status = 'loading'

        })
        builder.addCase(getAppSettings.fulfilled, (state, action)=> {
            state.status = 'succeeded'
            state.data = action.payload
          })
        builder.addCase(getAppSettings.rejected, (state, action)=> {
            state.status = 'failed'
            state.error = action.error.message || 'Failed to fetch business type data'
        })  
    },
})

export default appSettingsSlice.reducer;